export const tableToolbarType = {
    filterToolbar: 'filterToolbar',
    assignmentToolbar: 'assignmentToolbar',
    tableControlToolbar: 'tableControlToolbar',
}

export const exportTypes = {
    csv: 'csv',
    excel: 'excel',
    pdf: 'pdf',
}

export const exportRecordTypes = {
    inViewRecords: 'inViewRecords',
    allRecords: 'allRecords',
}

export const exportColumnTypes = {
    inViewColumns: 'inViewColumns',
    allColumns: 'allColumns',
}

export const datasetType = {
    minimal: 'minimal',
    advanced: 'advanced',
}

const textClass = 'text-darkcyan'
export const tableToolBarDescriptionList = {
    assignToStaticList: (
        <span>
            {' '}
            Add multiple patients to{' '}
            <span className={textClass}>your personal static list</span>{' '}
        </span>
    ),
    assignToPathway: <span>Add multiple pathways for multiple patients</span>,
    assignToHCP: <span>Add multiple HCPs for multiple patients</span>,
    filterByStaticList: (
        <span>
            Filter the patient list by{' '}
            <span className={textClass}>your personal static list</span>
        </span>
    ),
    filterByPathway: (
        <span>
            Filter the patient list by{' '}
            <span className={textClass}> pathways</span>{' '}
        </span>
    ),
    filterByHCP: (
        <span>
            Filter patients by{' '}
            <span className={textClass}> healthcare practitioner</span>{' '}
        </span>
    ),
    filterBySickness: (
        <span>
            Filter the patient list by{' '}
            <span className={textClass}> sickness level</span>
        </span>
    ),
    advanceFilter: (
        <span>Filter the data in a more detailed and clear table</span>
    ),
    editColumn: <span>Hide and show columns as you wish</span>,
    lockColumn: (
        <span>Lock and prioritize the display of your selected columns.</span>
    ),
    export: <span>Add and export the data of the table</span>,
    refresh: <span>Refresh and retrieve the latest data.</span>,
}
